import './jquery.fileupload';
import './jquery.iframe-transport';
import './jquery.ui.touch-punch';
import './jquery.ui.widget';
import './jquery.menu-aim';
import './jquery.validate.min';
import './lightbox';
// 以前は lodash.min.js (4.17.11) を同梱していた。脆弱性修正のため npm の lodash を使い、従来どおりグローバルの _ に置く
import _ from 'lodash';
window._ = _;
// import './modernizr';
import './remodal';
import './slick';
